import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';
import colors from '../../styles/colors';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .quill {
    display: flex;
    flex-direction: column;
  }

  .ql-container {
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid ${({ $error }) => ($error ? colors.base.danger : colors.base.beta)};

    &:hover {
      border-color: ${({ $error }) => ($error ? colors.base.danger : colors.base.beta)};
    }
    
    ${({ $focused, $error }) => $focused && !$error && css`
      border-color: ${colors.base.secondary};
      border-width: 2px;
    `}
  }

  .ql-editor {
    height: ${({ $height }) => `${$height}px`};
    overflow-y: auto;
    padding: 16px 14px;
    
    &.ql-blank::before {
      font-style: normal;
      color: ${colors.base.beta};
      left: 14px;
    }

    /* Style links to appear as hyperlinks */
    a, a.ql-link {
      color: ${colors.base.secondary};
      text-decoration: underline;
      cursor: text;
      
      &:hover {
        color: ${colors.shades.secondary1};
      }
    }
  }
`;

const HelperText = styled(Typography)`
  color: ${({ $error }) => ($error ? colors.base.danger : colors.base.beta)};
  font-size: 12px;
  margin-left: 14px;
  margin-top: 3px;
`;

export {
  Wrapper,
  HelperText,
};
